/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, ComponentFactoryResolver, ComponentRef, HostListener, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { Report } from '../../../../../model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ReportNotesInfoContentComponent } from './notes-info-content/notes-info-content.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'report-notes-info',
  templateUrl: 'notes-info.component.html',
  styleUrls: ['notes-info.component.scss']
})
export class ReportNotesInfoComponent {
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @Input() showHover = true;
  @Input() report: Report;
  @Input() size: number = 30;
  @Input() isLeft: boolean = false;

  private tooltip: ComponentRef<any>;
  private visible: boolean;

  editModal: BsModalRef;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver
  ) { }

  showInfo(): void {
    if (this.visible) {
      return;
    }

    this.visible = true;
    const factory = this.resolver.resolveComponentFactory(ReportNotesInfoContentComponent);
    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;
    this.tooltip.instance.report = this.report;
    const ackSubject = new Subject<boolean>();
    this.tooltip.instance.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value) {
        this.visible = false;
        if (this.tooltip) {
          this.tooltip.destroy();
        }
      }
    });
  }

  // @HostListener('focusout')
  @HostListener('mouseleave')
  hideInfo(): void {
    if (!this.visible) {
      return;
    }

    this.visible = false;
    if (this.tooltip) {
      this.tooltip.destroy();
    }

    /* if (!(!this.tooltip.instance.loadingDup && !this.tooltip.instance.loading && this.tooltip.instance.isPdfFile() === true && this.tooltip.instance.hasPreview() === true)) {
      this.visible = false;
      if (this.tooltip) {
        this.tooltip.destroy();
      }
    } */
  }
}


